import React from 'react';

import type { OnClickProp } from '@swf/core/types/Props';
import type { State as StateType } from '@swf/core/types/i18n';

import ListItem from '../../../ListItem/ListItem';

type Props = OnClickProp & StateType;

const State: React.FunctionComponent<Props> = ({ text, ...props }) => (
  <ListItem primary={text} {...props} textOnly />
);

export default State;
